import { render, staticRenderFns } from "./ReviewModal.vue?vue&type=template&id=0a076a75"
import script from "./ReviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports